<div class="hb-page">
  <nav class="hb-skiplinks">
    <a href="#hovedinnhold" class="hb-skiplinks-link" (click)="gaaTilHovedinnhold()" [routerLink]="finnUrl()" [fragment]="'hovedinnhold'"> Hopp til hovedinnhold </a>
  </nav>
  <div class="hb-page-header">
    <hb-header-v2 serviceName="Statistikkbanken" baseURL="/" [menu]="meny"></hb-header-v2>
  </div>
  <main class="hb-page-main">
    <ng-container class="hb-container hb-container--width-lg">
      <div id="feilmelding" class="hb-callout hb-callout--destructive" style="display: none">Dersom du opplever problemer med å laste siden, trykk F5 for å oppdatere siden</div>
    </ng-container>
    <div id="hovedinnhold" class="hb-screenreader-only hb-set-focus" tabindex="-1">
      <span>Hovedinnhold</span>
    </div>
    <router-outlet></router-outlet>
  </main>
  <div class="hb-page-footer">
    <stat-footer></stat-footer>
  </div>
</div>
